var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroundnuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "groundnuts",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aardnoten") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aardnoten",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(30.000000, 20.000000)",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.611459,31.4556187 C37.3090893,33.0914619 35.1630893,33.9923021 32.5696057,33.9923021 C29.575583,33.9923021 26.2847935,32.7771586 23.5400439,30.6576464 C21.7860726,29.3038077 21.0525288,27.8723431 20.2025843,26.2147863 C19.2722026,24.399535 18.2174588,22.3421778 15.7670053,20.4501149 C14.2990941,19.3163971 12.7581579,18.6981043 11.2682844,18.0998965 C9.73723129,17.4848607 8.29128249,16.9045665 6.80991934,15.7608062 C2.44489448,12.3905946 0.757359393,7.03006634 3.12463042,4.05558385 C4.17607981,2.73458684 5.92044257,2.00718351 8.03679331,2.00718351 C10.5218376,2.00718351 13.2583513,3.01957695 15.5454597,4.78542995 C16.9277175,5.8531929 17.653849,6.77493234 18.4950085,7.84269529 C19.4358224,9.03639672 20.5018219,10.3888784 22.5292249,11.954424 C25.7014175,14.4039819 28.0247638,14.9321635 29.8918414,15.3572059 C31.4036773,15.7016368 32.5978823,15.973056 34.2269425,17.2308123 C36.91157,19.3036404 38.8192781,21.9904186 39.5978448,24.7966212 C40.3173875,27.3870456 39.9670874,29.7524635 38.611459,31.4556187 Z M35.4842893,15.6508815 C31.2675105,12.3954801 29.1075095,14.4835077 23.7862972,10.375036 C20.2152127,7.61768881 20.043357,5.70798365 16.8025319,3.20604191 C11.4695147,-0.911929472 4.62713238,-1.08590915 1.52082695,2.81709826 C-1.58602754,6.72064851 0.219006326,13.2227657 5.55257255,17.3410085 C8.79284856,19.8432217 11.8840548,20.0025447 14.5096585,22.0297744 C18.7022786,25.2669906 18.0659184,28.9816331 22.2829716,32.2375773 C28.541429,37.0699239 36.5700549,37.2745739 40.215537,32.6941043 C43.861019,28.1133633 41.7430211,20.4837709 35.4842893,15.6508815 L35.4842893,15.6508815 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7319289,27.1938293 C25.543277,28.0208294 22.3667344,28.5293869 23.0858923,28.6459574 C24.3789635,29.1932884 26.0452221,29.0246864 27.4018868,28.0803654 C28.7580282,27.1365446 29.4426415,25.6691572 29.3028924,24.3188406 C29.2419158,23.8488064 27.9200574,26.3668291 26.7319289,27.1938293",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5873455,28.5798135 C25.3305736,27.2870163 21.8477159,23.5636264 22.2156234,24.3754547 C22.6015175,26.0997851 24.3478518,28.1297419 26.9240219,29.6048335 C29.5004645,31.0804401 32.2186196,31.6074977 34.0235465,31.1376003 C34.6252797,31.0008794 29.8443898,29.8723532 27.5873455,28.5798135",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1175851,29.2804366 C32.7701744,28.3380709 35.0906467,25.1425654 34.8507139,25.9579121 C34.834999,27.5593542 33.7388853,29.2743756 31.852537,30.3498215 C29.9661886,31.4250039 27.7930435,31.5736321 26.2041556,30.8876762 C25.6575018,30.6354827 29.4647152,30.2228024 31.1175851,29.2804366",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8121545,26.5230449 C31.7593162,27.6778593 36.4495732,28.7297643 35.546088,28.7956056 C33.747144,29.2334241 31.2365415,28.7748681 29.0146155,27.4562282 C26.7918869,26.1378475 25.4507051,24.3111411 25.3592062,22.751688 C25.3094436,22.2402517 27.8652605,25.367712 29.8121545,26.5230449",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65598431,12.1949234 C9.37820709,13.3770131 9.86127587,16.1496056 9.58501933,15.574639 C8.84520937,14.6165444 8.52105146,13.1843498 8.83836632,11.8357067 C9.15542773,10.4870636 10.0295643,9.58173847 11.0390412,9.3926481 C11.3941195,9.33713028 9.93376153,11.0139331 9.65598431,12.1949234",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57985159,12.3528252 C10.2285245,13.8384694 14.1158683,15.7609105 13.3800597,15.64737 C11.9295541,15.7154943 9.85358299,14.7860651 7.97240134,13.0899035 C6.09065672,11.3945433 4.90559391,9.3844756 4.75612399,7.87452041 C4.69053738,7.37520933 6.93174167,10.8669139 8.57985159,12.3528252",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51789208,9.90191454 C6.74532306,8.41869095 8.31896672,5.93581456 7.83133085,6.29617041 C6.76245487,6.65078898 5.88153223,7.86763883 5.62207221,9.56068296 C5.36286048,11.2534539 5.79413517,12.9708132 6.64203563,14.0559788 C6.94444932,14.4261699 6.29070938,11.3854113 6.51789208,9.90191454",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73805111,10.4817599 C7.3842987,9.16480754 5.36360876,5.62153362 5.56055149,6.36139146 C5.73160135,7.90129987 6.73880779,9.82044953 8.28427205,11.3231086 C9.82999785,12.8260376 11.5028341,13.5113711 12.6455204,13.2498161 C13.0258056,13.1801761 10.0928497,11.7981724 8.73805111,10.4817599",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "pinda",
    xmlSpace: "preserve",
    x: 24,
    y: 123,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "pinda"), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 8,
    y: 103,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "aardnoten"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundnuts);
export default __webpack_public_path__ + "static/media/groundnuts.bb2b41896b801b39542f295273b3b7f8.svg";
export { ForwardRef as ReactComponent };